import React from "react";
import classes from "./Homepage.module.css";
import Navbar from "../components/General/Navbar";
import Intro from "../components/Homepage/Intro";
import Info from "../components/Homepage/Info";
import Card from "../components/Homepage/Card";
import CardContainer from "../components/Homepage/CardContainer";
import Footer from "../components/General/Footer";
import Education from "../components/Homepage/Education";
import SchoolsContainer from "../components/Homepage/SchoolsContainer";

function Homepage() {
  return (
    <div>
      <Navbar onPage="Home" />
      <Intro />
      <Info />
      <CardContainer>
        <Card
          title="Front-end"
          content={
            <span className={classes.span}>
              Typescript <br /> React <br /> Javascript <br /> SASS / SCSS
              <br />
              Bootstrap <br /> React Native <br /> HTML
            </span>
          }
        />
        <Card
          title="Back-end"
          content={
            <span className={classes.span}>
              Spring Framework <br /> MongoDB <br /> Node.js <br /> PostgreSQL{" "}
              <br />
              NoSQL <br /> Python Chalice <br /> AWS
            </span>
          }
        />
        <Card
          title="Other"
          content={
            <span className={classes.span}>
              PineScript <br /> Figma <br /> C <br />
              Trading Bots <br /> Python
            </span>
          }
        />
      </CardContainer>
      <Education />
      <SchoolsContainer />
      {/* <Footer /> */}
    </div>
  );
}

export default Homepage;
